import { Icon, SvgLink } from '@loomhq/lens';
import React from 'react';

function EmbedThumbnailDropdownItem({ onClick }) {
  return (
    <li className="copy-link-item" onClick={onClick}>
      <Icon icon={<SvgLink />} size="1rem" />
      <span>Linked GIF</span>
    </li>
  );
}

export default EmbedThumbnailDropdownItem;
